import { render, staticRenderFns } from "./NsIcon.vue?vue&type=template&id=84b34b50&scoped=true&"
import script from "./NsIcon.vue?vue&type=script&lang=js&"
export * from "./NsIcon.vue?vue&type=script&lang=js&"
import style0 from "./NsIcon.vue?vue&type=style&index=0&id=84b34b50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84b34b50",
  null
  
)

export default component.exports